import React from "react";
import { useTranslation } from "react-i18next";
import i18n from "./i18n";

import {TranslationContext} from "./context";
import { ILanguageOptionsAvailable } from "./interface";

const TranslationsProvider: React.FC = ({children}) => {
	const { t: translate } = useTranslation();
	
	const changeLanguage = (lng: "pt" | "en" | "es") => {
		i18n.changeLanguage(lng);
	};

	const currentLanguage = i18n.language as ILanguageOptionsAvailable;

	return(
		<TranslationContext.Provider
			value={{
				changeLanguage,
				translate,
				currentLanguage
			}}
		> 
			{children} 
		</TranslationContext.Provider>
	);
};

export default TranslationsProvider;
